import React from 'react';
import c from 'classnames';
import ArrowRightIconNew from '@wix/da-ds/pkg/Icons/ArtStageArrowR';
import commonStyles from '../../Slider.scss';
const DefaultNextButton = ({ onClick, className, arrowSize, iconClassName })=>{
    return /*#__PURE__*/ React.createElement("button", {
        className: c(commonStyles['next-btn'], className),
        onClick: onClick,
        /**
       * We can hide these from screen readers because they have
       * access to all of the slider content without these buttons
       */ "aria-hidden": 'true'
    }, /*#__PURE__*/ React.createElement(ArrowRightIconNew, {
        withPadding: false,
        className: c(commonStyles['arrow-icon'], iconClassName),
        size: arrowSize
    }));
};
DefaultNextButton.displayName = 'DefaultNextButton';
export default DefaultNextButton;
